import accounting from 'accounting-js';
import getSymbolFromCurrency from 'currency-symbol-map';

export const formatAsCurrency = accounting.format;

export const currencyToFloat = value => (value ? parseFloat(value.replace(/[^0-9-.]/g, '')) : 0);

export const calculateAndFormatTotal = (amounts, options = {}) => {
  if (!amounts) {
    return '$0.00';
  }
  const getSum = (total, num) => total + num;
  let total = amounts.reduce(getSum).toFixed(2);
  let dollars = (total / 100).toFixed(2);
  return accounting.formatMoney(dollars, options);
};

export const centsToDollars = (cents, options = {}) => {
  let dollars = (cents / 100).toFixed(2);
  return accounting.formatMoney(dollars, options);
};

const CurrencyHelpers = {
  centsToDollars,
  calculateAndFormatTotal,
  currencyToFloat,
};

CurrencyHelpers.getCurrencySymbol = currencyCode => {
  if (currencyCode) {
    return getSymbolFromCurrency(currencyCode);
  }
};

export default CurrencyHelpers;



// WEBPACK FOOTER //
// ./src/lib/helpers/CurrencyHelpers/index.js